import { render } from "./popupAlert.vue?vue&type=template&id=23f099ed&scoped=true"
import script from "./popupAlert.vue?vue&type=script&lang=js"
export * from "./popupAlert.vue?vue&type=script&lang=js"

import "./popupAlert.vue?vue&type=style&index=0&id=23f099ed&scoped=true&lang=css"

import exportComponent from "/Users/dudgh/git/project/fognet/admin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f099ed"]])

export default __exports__